export default "__VITE_ASSET__BsxdCTn9__"